import config from '~/config';

export const formatCondensedHumanMonth = (date: Date, includeYear = false, locale: string[] = config.locale) =>
	Intl.DateTimeFormat(locale, {
		month: 'long',
		year: includeYear && date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined,
	})
		.format(date)
		.replace(/ /g, '\xA0');
